import { WalletAddress } from "./Ether";

export enum PMToolEndpoints {
  TEMPLATES_GET = '/templates',
  TEMPLATES_UPDATE = '/templates/update',
  TEMPLATES_CREATE = '/templates/create',
  PROJECT_TEMPLATES_GET = '/templates/project',
  PROJECT_TEMPLATES_CREATE = '/templates/project/create',
  PROJECT_TEMPLATES_UPDATE = '/templates/project/update',
  ASSETS_EXCLUSIVE_GET = '/assets/exclusive',
  USER_GET = '/user',
  USER_UPDATE = '/user/update',
  USER_CREATE = '/user/create',
  STORY_GET = '/story',
  STORY_UPDATE = '/story/update',
  STORY_GENERATE = '/story/generate',
  STORY_CAST = '/story/setcast',
  STORY_PUBLISH = '/story/publish',
  STORY_PUBLISH_PROD = '/story/publish/prod',
}

export interface CharData {
  name: string;
  metadataUrl: string;
}

export interface ExclusiveAssets {
  bgs: string[];
  chars: CharData[];
}

export interface ProjectTemplateData {
  name: string;
  walletAddress: WalletAddress;
}
